import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './header/navbar.component';
import { GameService } from '../core/state/game.service';
import { ClubProfileComponent } from '../shared/ui/club-profile/club-profile.component';
import { ClubShieldEditorComponent } from '../shared/ui/club-shield/club-shield-editor.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NavbarComponent, ClubProfileComponent, ClubShieldEditorComponent],
  template: `
    <div class="min-h-screen bg-slate-50 text-slate-900 dark:bg-[#09090b] dark:text-slate-100 flex flex-col antialiased selection:bg-emerald-600 selection:text-white transition-colors duration-200">
      <app-navbar />

      <main class="flex-1 max-w-7xl w-full mx-auto px-1 sm:px-6 lg:px-8 py-2 sm:py-6 pb-20 sm:pb-8">
        <router-outlet />
      </main>

      @if (game.selectedClubProfile(); as club) {
        <app-club-profile
          [clubId]="club.id"
          [clubName]="club.name || ''"
          [clubCode]="club.code || ''"
          [isUserClub]="club.id === game.activeUserClubId() || club.id === game.userClub()?.id"
          (customizeShield)="game.openClubShieldEditor(club.id, club.name, club.code)"
          (closed)="game.closeClubProfile()"
        />
      }

      @if (game.isClubShieldEditorOpen()) {
        @if (game.editingShieldClub(); as club) {
          <app-club-shield-editor
            [clubId]="club.id"
            [clubName]="club.name || ''"
            [clubCode]="club.code || ''"
            [isOpen]="true"
            [canAdminister]="club.canAdminister ?? null"
            (saved)="game.onClubShieldSaved($event, club.id); game.closeClubShieldEditor()"
            (closed)="game.closeClubShieldEditor()"
          />
        }
      }
    </div>
  `,
})
export class MainLayoutComponent {
  readonly game = inject(GameService);
}
